import React from 'react';
import { Box, Divider, Grid, IconButton, Typography } from '@mui/material';
import Ameneties from './Ameneties';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import { COLOR_PRIMARY_2 } from 'src/colors';
import { formatCurrency } from 'src/utils/functions';

const ImageGrid = ({ imageLinks, listingUrl, isMobileScreen }) => {
  const isOnlyOneListingPresent = imageLinks.length === 1;

  return (
    <Box
      onClick={() => window.open(listingUrl)}
      sx={{
        position: 'relative',
        display: 'flex',
        flexWrap: 'nowrap',
        height: '300px',
        width: '100%',
        gap: isOnlyOneListingPresent ? 0 : '10px',
        padding: '20px',
        paddingRight: 0,
        cursor: 'pointer',
        marginTop: '20px',
      }}
    >
      <Box
        sx={{
          flex: 1,
          height: '100%',
          borderRadius: '10px',
          overflow: 'hidden',
        }}
      >
        <img
          src={imageLinks[0]}
          alt="Main"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>

      {/* Smaller Images */}
      {!isOnlyOneListingPresent && !isMobileScreen && (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            flex: 1,
            gap: '20px',
          }}
        >
          {imageLinks.slice(1).map((src, index) => (
            <Box
              key={index}
              sx={{
                width: 'calc(50% - 20px)',
                height: 'calc(50% - 10px)',
                borderRadius: '10px',
                overflow: 'hidden',
              }}
            >
              <img
                src={src}
                alt={`Thumbnail ${index + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          ))}
        </Box>
      )}

      <IconButton
        onClick={() => window.open(listingUrl)}
        sx={{
          position: 'absolute',
          top: '5px',
          right: '0px',
          background: '#fff',
          border: '1px solid #ccc',
          boxShadow: '0 4px 12px -4px #0002',
        }}
      >
        <LaunchRoundedIcon />
      </IconButton>
    </Box>
  );
};

const TitleBar = ({ data }) => {
  return (
    <>
      <Grid
        container
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        sx={{ width: '100%', padding: '0 0 20px 20px' }}
      >
        <Typography variant="h6" sx={{ marginBottom: '20px' }}>
          Entire home hosted by <span style={{ color: COLOR_PRIMARY_2 }}>{data['host_name']}</span>
        </Typography>

        <Grid
          item
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '10px',
            paddingBottom: '20px',
          }}
        >
          <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <span style={{ fontWeight: 'bold' }}>
              <span style={{ color: 'gold' }}>★</span> {data['review_scores_rating']}
            </span>{' '}
            <Typography variant="body1">Rating</Typography>
          </Typography>
          <Divider orientation="vertical" variant="middle" flexItem />
          <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <span style={{ fontWeight: 'bold' }}>
              {data['visible_review_count']
                ? formatCurrency(String(data['visible_review_count']))
                : data['visible_review_count']}
            </span>{' '}
            <Typography variant="body1">Reviews</Typography>
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        sx={{ width: '100%', padding: '0 0 20px 20px' }}
      >
        {[
          { title: 'Bedrooms', value: data['bedrooms'] },
          { title: 'Bathrooms', value: data['bathrooms'] },
          { title: 'Accommodates', value: data['accommodates'] },
        ].map(data => (
          <Typography variant="h5">
            <span style={{ fontWeight: 'bold', color: COLOR_PRIMARY_2 }}>{data['value']}</span>
            <Typography variant="body1">{data['title']}</Typography>
          </Typography>
        ))}
      </Grid>
    </>
  );
};

const ListingDetailsSection = ({ data, isMobileScreen }) => {
  const thumbnailUrl = data['thumbnail_url'];
  const listingUrl = `https://www.airbnb.com/rooms/${data['listingID']}`;

  let restThumbnails = data['rest_thumbnails'];
  if (restThumbnails && typeof restThumbnails === 'string') {
    restThumbnails = restThumbnails.replace('[', '').replace(']', '');
    restThumbnails = Array.from(restThumbnails.replace(/'/gi, '').split(','));
  }

  const imageLinks = [thumbnailUrl, ...(restThumbnails ? restThumbnails : [])]
    .slice(0, 5)
    .map(image => image.split('?')[0]);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        sx={{ width: isMobileScreen ? '100%' : '100%' }}
        spacing={isMobileScreen ? 0 : 4}
        xs={12}
      >
        <ImageGrid
          imageLinks={imageLinks}
          listingUrl={listingUrl}
          isMobileScreen={isMobileScreen}
        />

        <TitleBar data={data} />

        <Grid
          container
          flexDirection={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          sx={{ width: '100%', padding: '0 0 20px 20px' }}
        >
          <Ameneties data={data} isMobileScreen={isMobileScreen} />
        </Grid>
      </Grid>
    </>
  );
};

export default ListingDetailsSection;
